/**
 * A global namespace for `select` event.
 */
const selectEvent = "select";
export default selectEvent;
